// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ywYEgysRG6bQ4U {\n  text-align: center;\n}\n.ywYEgysRG6bQ4U .qqe6LZdaVAMpnx {\n  text-align: left;\n  margin-bottom: 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warningPopover": "ywYEgysRG6bQ4U",
	"warningContent": "qqe6LZdaVAMpnx"
};
export default ___CSS_LOADER_EXPORT___;
